import './GaugeLabel.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var elementLabelWrapper = '_2e52ks0-2-0-1';
export var foreignObjectContainer = _7a468({defaultClassName:'_2e52ks1-2-0-1',variantClassNames:{dominantBaseline:{auto:'_2e52ks2-2-0-1',hanging:'_2e52ks3-2-0-1'}},defaultVariants:{dominantBaseline:'hanging'},compoundVariants:[]});
export var textContainer = '_2e52ks4-2-0-1';